import {
    AnimationBaseController,
    GameApiBase, GameRandom,
    GameStorageManager
} from "@denishussar/html5-game-engine";
import {Inject} from "@denishussar/html5-game-engine";
import {IAnimationControllerConfiguration} from "@denishussar/html5-game-engine";
import {GameModel} from "../../../Models/GameModel";
import {AnimationContents} from "../../AnimationContents";
import {GameLogic} from "../../../Logic/GameLogic";

import {ButtonController, IButtonControllerOptions} from "../../Common/ButtonController";
import {SwitchController, ISwitchControllerOptions} from "../../Common/SwitchController";
import {DropDownMenuController, IDropDownMenuControllerOptions} from "../../Common/DropDownMenuController";
import {LocalizationContents} from "../../../LocalizationContents";
import { SoundConstants } from "../../../Constants/SoundConstants";

export interface IIntroScreenControllerOptions
{
}

export class SettingsScreenController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options:IIntroScreenControllerOptions,
                       @Inject private _random: GameRandom,
                       @Inject private _gameLogic: GameLogic,
                       @Inject private _arenaApi: GameApiBase) {
        super("SettingsScreenController");
        console.log('SettingsScreenController', this);

    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.SETTINGS_SCREEN_JSON,
            libraryName: "settings",
            childControllers: {
                CloseButton: {
                    instanceName: "close_button",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this._gameLogic.hidenModal();
                            this._gameLogic.showMainMenu();
                        }
                    }
                },
                SoundButton: {
                    instanceName: "sound_button",
                    view: SwitchController,
                    model: this.$model,
                    options: <ISwitchControllerOptions>{
                        onClick: () =>{
                            this._gameLogic.setSoundsOn(!this.$model.isSoundsOn);
                        }
                    }
                },
                MusicButton: {
                    instanceName: "music_button",
                    view: SwitchController,
                    model: this.$model,
                    options: <ISwitchControllerOptions>{
                        onClick: () => {
                            this._gameLogic.setMusicOn(!this.$model.isMusicOn);
                        }
                    }
                },
                MenuButton: {
                    instanceName: "menu_button",
                    view: DropDownMenuController,
                    model: this.$model,
                    options: <IDropDownMenuControllerOptions>{
                        onClick: () =>{
                            console.log("menu button click");
                        }
                    }
                },
            },
            modelWatch: {
                lang: (lang: string)=> {
                    console.log('lang', lang);

                    this.updateLocale();
                }
            }
        };
    }

    protected onInitialize(): void {
        this.$childControllers.get<SwitchController>('MusicButton').setChecked(this.$model.isMusicOn);
        this.$childControllers.get<SwitchController>('SoundButton').setChecked(this.$model.isSoundsOn);
        this.updateLocale();
    }

    protected onLandscape(): void {
        this.display.scale.set(.65);
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }

    private updateLocale() {
        this.setTextByQuery("txt_title.menu_settings", LocalizationContents.menu_settings);
        this.setTextByQuery("txt_sound.settings_sounds", LocalizationContents.settings_sounds);
        this.setTextByQuery("txt_music.settings_music", LocalizationContents.settings_music);
        this.setTextByQuery("txt_language.settings_lang", LocalizationContents.settings_lang);
    }
}

